import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { supabase } from '@/lib/supabaseClient';

export interface MensualResumen {
  anio: number;
  mes: number;
  total_reservas: number;
  ingresos_mes: number;
  gastos_mes: number | null;
}

interface Respuesta {
  mensual: MensualResumen[];
  mensualAnterior: MensualResumen[];
  primerAnio: number;
}

export const useResumenAnual = (empresaId: string, anio: number) => {
  const [loading, setLoading] = useState(true);
  const [mensual, setMensual] = useState<MensualResumen[]>([]);
  const [mensualAnterior, setMensualAnterior] = useState<MensualResumen[]>([]);
  const [primerAnio, setPrimerAnio] = useState<number>(new Date().getFullYear());

  useEffect(() => {
    if (!empresaId) return;
    let cancelado = false;

    const load = async () => {
      setLoading(true);
      const { data, error } = await supabase.rpc('get_resumen_anual', {
        p_empresa: empresaId,
        p_anio: anio,
      });
      if (cancelado) return;

      if (error) {
        Sentry.captureException(error, { extra: { empresaId, anio } });
        setLoading(false);
        return;
      }

      const res = data as Respuesta;
      setMensual(res?.mensual ?? []);
      setMensualAnterior(res?.mensualAnterior ?? []);
      if (res?.primerAnio) setPrimerAnio(Number(res.primerAnio));
      setLoading(false);
    };

    load();
    return () => {
      cancelado = true;
    };
  }, [empresaId, anio]);

  return { loading, mensual, mensualAnterior, primerAnio };
};
